import React, { useEffect } from 'react'
import withReactContent from 'sweetalert2-react-content'
import Swal from 'sweetalert2'
import { useHistory, useParams } from 'react-router-dom'
import { MunicipalityNaneFrontSetting } from '../../config'

export default function AdresDogrulama() {

    const dogrulamaKodu = useParams().id
    const history = useHistory()
    const MySwal = withReactContent(Swal)

    const checkParams = () => {
        if(dogrulamaKodu.length < 5 ){
            history.push('/adres-dogrulama')
            return
        } else {
            checkToken()
        }
    }

    const checkToken = () => {
        MySwal.fire({
            width:'90%',
            showConfirmButton:false,
            showCancelButton:false,
            showClass:false,
            html:<iframe title={'Adres Tespit Belgesi'} src={`${MunicipalityNaneFrontSetting.nodeURL}pdfSorgu/get/adres/kod/sorgula/${dogrulamaKodu}`} width="100%" height="700px"></iframe>
        })
    }

    useEffect(() => {
        let isMounted = true
        if(isMounted){
            checkParams()
            
        }
        return () => {
            isMounted = false
        }
    }, [])

    return (
        <div>
            <h2>Adres Kodu Doğrulama</h2>
        </div>
    )
}
